import { CarrierLogo } from '@/components/carrier-logo';
import { ImageWithFallback } from '@/components/ui/image-with-fallback';
import { ShipmentModel } from '@/lib/models/shipment/types';

export interface CarrierIconProps {
  shipment: ShipmentModel;
  className?: string;
}

const InfoCardCarrierIcon = ({ shipment, className }: CarrierIconProps) => {
  const { trackingData, parcelNumber, journey } = shipment;
  const { carrierScac } = trackingData || {};
  const currentSegment = (journey?.segments || []).find((s) => s.isCurrent);
  const currentVehicleMode = currentSegment?.mode;

  if (parcelNumber) {
    return (
      <ImageWithFallback
        className={className}
        fallbackSrc="/logos/mail-carriers/missing.png"
        src={`/logos/mail-carriers/${shipment.carrier}_logo.png`}
        alt={shipment.carrier || 'Carrier logo'}
        width={24}
        height={24}
      />
    );
  }
  if (carrierScac) {
    return <CarrierLogo carrierCode={carrierScac} mode={currentVehicleMode} className={className} />;
  }
  return null;
};

export { InfoCardCarrierIcon };
